import React, { useEffect, useState } from "react";
import { getDeveloperDetails, updateDeveloperDetails } from "../../api";
import { ClipLoader } from "react-spinners";
import { Copy } from "lucide-react";

export default function DeveloperSection() {
  const [formData, setFormData] = useState({
    webhook_payin: "",
    webhook_payout: "",
    ip: "",
    api_password: "",
    secret_key: "",
    user_token: "",
    ip_approved: "",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const userToken = user?.user_token;

  useEffect(() => {
    const fetchDeveloper = async () => {
      if (!userToken) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const { data } = await getDeveloperDetails({ user_token: userToken });
        if (data && data.data) setFormData(data.data);
      } catch (error) {
        console.error("Error fetching developer details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDeveloper();
  }, [userToken]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await updateDeveloperDetails({
        user_token: userToken,
        webhook_payin: formData.webhook_payin,
        webhook_payout: formData.webhook_payout,
        ip: formData.ip,
      });
      alert("✅ Developer details updated successfully!");
    } catch (error) {
      alert("❌ Could not update. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("📋 Copied to clipboard!");
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-white">
        <ClipLoader size={50} color="#000" />
      </div>
    );
  }

  return (    <div className="main-content">
  <div className="main-content-inner">
    <div className="main-content-wrap">
      <div className="tf-container">
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white w-full max-w-2xl p-5 border rounded shadow-md"
      >
        <h2 className="text-2xl font-bold text-center text-gray-800 mb-5">
          API Tokens & Webhooks
        </h2>

        {/* API Tokens - readonly with copy */}
        {[
          { label: "API Password", value: formData.api_password },
          { label: "User Token", value: formData.user_token },
          { label: "Secret Key", value: formData.secret_key },
        ].map((item) => (
          <div key={item.label} className="mb-4">
             <label className="form-label fw-semibold text-black" style={{fontSize: "20px"}} >
              {item.label}
            </label>
            <div className="flex gap-3">
              <input
                type="text"
                value={item.value}
                readOnly
                className="form-control border border-black rounded"
              />
              <button
                type="button"
                onClick={() => copyToClipboard(item.value)}
                className="bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded flex items-center gap-2 font-medium"
              >
                <Copy size={16} /> Copy
              </button>
            </div>
          </div>
        ))}

        {/* Editable inputs */}
        <div className="mb-4">
           <label className="form-label fw-semibold text-black" style={{fontSize: "20px"}} >
            Webhook Payin
          </label>
          <input
            type="url"
            name="webhook_payin"
            value={formData.webhook_payin}
            onChange={handleChange}
           className="form-control border border-black rounded"
            placeholder="https://yourdomain.com/payin"
          />
        </div>

        <div className="mb-4">
           <label className="form-label fw-semibold text-black" style={{fontSize: "20px"}} >
            Webhook Payout
          </label>
          <input
            type="url"
            name="webhook_payout"
            value={formData.webhook_payout}
            onChange={handleChange}
           className="form-control border border-black rounded"
            placeholder="https://yourdomain.com/payout"
          />
        </div>

        <div className="mb-5">
           <label className="form-label fw-semibold text-black" style={{fontSize: "20px"}} >
            Allowed IP
          </label>
          <input
            type="text"
            name="ip"
            value={formData.ip}
            onChange={handleChange}
           className="form-control border border-black rounded"
            placeholder="Enter allowed IP"
          />
        </div>

        {/* Submit */}
        <button
          type="submit"
          disabled={saving}
          className="btn btn-dark w-100 py-2 my-2 fw-semibold" style={{fontSize: "20px"}}
        >
          {saving ? "Saving..." : "Update"}
        </button>
      </form>
    </div></div></div></div></div>
  );
}
